type ShouldReloadForChunkLoadParams = {
  localRevision: string | undefined;
  remoteRevision: string | null;
  hasAlreadyReloaded: boolean;
};

// Only reload when the running bundle is provably out of date. Reloading on any
// chunk failure would loop forever whenever the cause is something else (an
// offline blip, a genuine CORS fault), and reloading twice for the same deploy
// would loop on a chunk the new bundle also fails to serve.
export function shouldReloadForChunkLoad({
  localRevision,
  remoteRevision,
  hasAlreadyReloaded,
}: ShouldReloadForChunkLoadParams): boolean {
  if (hasAlreadyReloaded) {
    return false;
  }
  if (!localRevision || !remoteRevision) {
    return false;
  }
  return localRevision !== remoteRevision;
}
